import { RACHEL_ASK_USER_PART_TYPE, RACHEL_ASK_USER_SKIPPED_ANSWER } from './rachel.consts';
import { RachelUIMessage } from './rachel.types';

type RachelPart = RachelUIMessage['parts'][number];
export type RachelAskUserPart = Extract<RachelPart, { type: typeof RACHEL_ASK_USER_PART_TYPE }>;

export interface RachelAskUserAnswerEntry {
  question: string;
  answer: string;
}

export const isAskUserPart = (part: RachelPart): part is RachelAskUserPart =>
  part.type === RACHEL_ASK_USER_PART_TYPE;

const getLastStepParts = (message: RachelUIMessage): RachelPart[] => {
  const lastStepStartIndex = message.parts.findLastIndex((part) => part.type === 'step-start');
  return message.parts.slice(lastStepStartIndex + 1);
};

export const findAnsweredAskUserPart = (message: RachelUIMessage) =>
  getLastStepParts(message).find(
    (part): part is RachelAskUserPart => isAskUserPart(part) && part.state === 'output-available',
  );

export const getAskUserAnswerEntries = (part: RachelPart): RachelAskUserAnswerEntry[] => {
  if (
    !isAskUserPart(part) ||
    part.state !== 'output-available' ||
    part.output.resposta === RACHEL_ASK_USER_SKIPPED_ANSWER
  ) {
    return [];
  }

  return [{ question: part.input.pergunta, answer: part.output.resposta }];
};
